<template>
    <div class="main">
        <div class="service-content-top">
			<div class="about-top">
				<img src="../assets/abtus_banner.png" style="max-width:100%;" width="100%" />
			</div>
			<el-container class="news-main-container">
				<el-aside width="200px" height="auto" style="">
					<el-menu :default-active="activeIndex" class="el-menu-demo" mode="vertical" @select="handleSelect">
					<li  class="" style="padding-left: 20px;height: 40px;background:#2fa5ff; color:#fff;    line-height: 40px; vertical-align: middle;line-height: 40px;">产品服务</li>
					<el-menu-item class="new-menu" index="0">智慧餐厅平台建设</el-menu-item>
					<el-menu-item class="new-menu" index="1">企业内购商城</el-menu-item>
					<el-menu-item class="new-menu" index="2">企业福利集采</el-menu-item>
					
					</el-menu>
				</el-aside>
				<el-container class="news-content">
					<el-main>
						<div class="el-menu-select-box">
							<ul>
								<li  v-show="showSelectPage == 0 "style="margin-top:10px;padding-top:10px;">
									<div class="main-title">&nbsp;&nbsp;&nbsp;智慧餐厅平台建设</div>
									<hr style="height:1px;border:none;border-top:1px solid #d0dee5;" />
									<div class="qyfljc">
										<h1>概述</h1>
										<p>
											帮助团餐企业为甲方职工餐厅搭建智慧餐厅服务平台，为甲方职工提供更加智能化的就餐服务。在线点餐、访客餐预约、员工建议反馈、员工点评/打赏、食品安全管控、智能取餐柜等功能一应俱全。特别是我们针对医院内容就餐的特殊情况特别定制开发了“医院点餐平台”深受好评。
										</p>
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
										<h1>平台架构</h1>
										<img src="../assets/cpfw-ptjg.png" style="margin:22px auto;display:block;width:92%;" alt="">
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
										<h1>平台展示</h1>
										<ul class="platform-box1">
											<li>
												<img src="../assets/ptzs1.png" alt="">
												<p>预约点餐</p>
											</li>
											<li>
												<img src="../assets/ptzs2.png" alt="">
												<p>员工点评</p>
											</li>
											<li>
												<img src="../assets/ptzs3.png" alt="">
												<p>供餐计划</p>
											</li>
											<li>
												<img src="../assets/ptzs4.png" alt="">
												<p>访客餐预约</p>
											</li>
											<li>
												<img src="../assets/ptzs5.png" alt="">
												<p>建议反馈</p>
											</li>
										</ul>
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
										<h1>智慧餐厅平台智能硬件产品</h1>
										<div class="hardware-roduct">
											<ul>
												<li>
													<div class="hardware-img">
														<img src="./../assets/cp1.png" alt="">
													</div>
													<div class="hardware-sm">
														<h5>智能餐厅台</h5>
														<span>（自动计价、刷脸支付、营养成分分析）</span>
													</div>
												</li>
												<li>
													<div class="hardware-img">
														<img src="./../assets/cp2.png" alt="">
													</div>
													<div class="hardware-sm">
														<h5>自助终端机</h5>
														<span>（自助充值、查询余额及明细、挂失/解挂）</span>
													</div>
												</li>
												<li>
												<div class="hardware-img">
													<img src="./../assets/cp3.png" alt="">
												</div>
													<div class="hardware-sm">
														<h5>安卓手持pos机</h5>
														<span>（刷卡收银，扫码收银，4G/wifi双网模式）</span>
													</div>
												</li>
												<li>
													<div class="hardware-img">
															<img src="./../assets/cp4.png" alt="">
													</div>
													<div class="hardware-sm">
														<h5>人脸支付机</h5>
														<span>（1秒支付，支持离线识别）</span>
													</div>
												</li>
												<li>
													<div class="hardware-img">
															<img src="./../assets/cp5.png" alt="">
													</div>
													<div class="hardware-sm">
														<h5>卧式POS机</h5>
														<span>（刷卡收银、扫码收银、自动计价、打印小票）</span>
													</div>
												</li>
											</ul>
										</div>

									</div>
								</li>
								<li v-show="showSelectPage == 1 "style="margin-top:10px;padding-top:10px;" >
									<div class="main-title">&nbsp;&nbsp;&nbsp;企业内购商城</div>
									<hr style="height:1px;border:none;border-top:1px solid #d0dee5;" />
									<div class="qyfljc">
										<h1>概述</h1>
										<p>
											当前，各大企事业单位均设有职工餐厅，且采用外包第三方团餐公司提供餐饮服务。企业定期为职工进行餐卡充值，但职工因各种情况导致餐卡余额无法消费完成，所以，餐厅设立小型的便利店，提供餐卡支付方式，方便员工购买日常家用物品。为此，我们特意为餐厅提供线上职工内购商城平台，主要为职工提供国家相关法规允许范围内的日常百货商品，支持餐卡在线支付，为广大职工提供更好的购物便利。
										</p>
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
										<h1>平台架构</h1>
										<img src="../assets/qyfljc-ngsc1.png" style="margin:22px auto;display:block;width:92%;" alt="">
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
										<h1>平台展示	</h1>
										<ul class="platform-box">
											<li>
												<img src="../assets/cpfw-ptzs1.png" alt="">
												<p>电子餐卡</p>
											</li>
											<li>
												<img src="../assets/cpfw-ptzs2.png" alt="">
												<p>企业商城（可定制）</p>
											</li>
											<li>
												<img src="../assets/cpfw-ptzs3.png" alt="">
												<p>商品分类</p>
											</li>
										</ul>
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
										<h1>供应链优势	</h1>
										<p>
											商家入驻审核：具备与家乐福、永辉、物美等线下商超或成功入驻京东、天猫、苏宁易购等主流电商平台任意一个
											为入驻的先决条件.
										</p>
										<img src="../assets/cpfw-gyl.png" style="padding-bottom:22px;margin:22px auto;display:block;width:92%;" alt="">
										<img src="../assets/cpfw-gyl3.png" style="padding-bottom:22px;margin:22px auto;display:block;width:550px;" alt="">

									</div>
								</li> 
								<li v-show="showSelectPage == 2 " style="margin-top:10px;padding-top:10px;">
									<div class="main-title">&nbsp;&nbsp;&nbsp;企业福利集采</div>
									<hr style="height:1px;border:none;border-top:1px solid #d0dee5;" />
									<!-- <img src="../assets/bg_tsqy.png" style=""  />  -->
									<div class="qyfljc">
										<h1>概述</h1>
										<p>
											应广大企事业单位的要求，中汇豪泰在实现餐卡余额消费、互联网智能点餐的主营业务之外，还探索性地将业务范围延申至企事业单位年节的慰问品发放方面，凭借自身强大的供应链的支持，公司为广大的企事业单位职工提供了品种丰富、质优价廉的节日慰问品，同时，基于互联网技术研发方面拥有的优势，在慰问品的采购发放环节，更打破了原有的实现形式，在保留了企业集中采购、分级发放的传统形式的同时，还以互联网手段实现了企业职工后台充值、自主线上选品的新型方式，极大程度地丰富了职工在节日慰问品方面的选择，进一步提升了职工的满意度。
										</p>
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
									</div>
									<div class="qyfljc">
										<h1 style="margin-bottom:38px;"> 业务流程</h1>
										<img src="../assets/qyfljc-ywlc.png" style="margin:0 auto;display:block;width:92%;" alt="">
										<img src="../assets/qyfljc-ywlcxs.png" style="margin:38px auto 40px auto;display:block;width:92%;" alt="">
										<hr  style="height:1px;border:none;border-top:1px solid #d0dee5;" />
										<h1 style="margin-top:45px;">联系合作</h1>
										<p class="qyfljc-lxr">
											<span>联系人: 李先生</span>
											<span style="margin-left:40px;">电话&微信：13911633995</span>
										</p>
									</div>

								</li>
								
							</ul>
						</div>
						<div class="service-content-apy" >
						<p>
							<img src="../assets/title_apy.png"  height="30px" width="auto" style="padding-top:  60px;padding-bottom: 31px;"/>
						</p>
						<div  class="form-apy">
							<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
								<el-form-item label="合作产品：" prop="type">
								<el-checkbox-group v-model="ruleForm.type">
									<el-checkbox label="商家入驻" name="type" key="1"></el-checkbox>
									<el-checkbox label="企业点餐平台" name="type" key="2"></el-checkbox>
									<el-checkbox label="线上商城" name="type" key="3"></el-checkbox>
								</el-checkbox-group>
								</el-form-item>
								<el-form-item label="公司名称：" prop="name">
								<el-input v-model="ruleForm.name"></el-input>
								</el-form-item>
								<el-form-item label="联 系 人：" prop="people">
								<el-input v-model="ruleForm.people"></el-input>
								</el-form-item>
								<el-form-item label="手 机 号：" prop="phone">
								<el-input v-model="ruleForm.phone"></el-input>
								</el-form-item>
								<el-form-item>
								<el-button type="primary" @click="submitForm('ruleForm')">立即提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					</el-main>
					
				</el-container>
				
			</el-container>
		</div>
		
    </div>
</template>

<script>
import axios from 'axios';
var querystring = require('querystring');
export default {
  name: 'index',
  data () {
    return {
      bg_images: [require('../assets/bg_banner.jpeg')],
      cb_images: [require('../assets/logo_jt.png'),require('../assets/logo_jt_1.png'),require('../assets/logo_jt_2.png'),require('../assets/logo_jt_3.png')],
      headerFixed:true,
      //banners: [ '/1.jpg', '/2.jpg', '/3.jpg' ],
      bannert:'/bg_banner.jpeg',
      height:"400px",
      cb_height:"400px",
      cb_carousel_height:"300px",
      horizontal:false,
      vertical:true,
      menuDisplay:'none',
      activeIndex:"0",
      isActive1:false,
      isActive2:false,
      isActive3:false,
      activeNewsIndex: -1,
      ruleForm: {
          name: '',
          people: '',
          phone: '',
          type: [],
        },
      rules:{
        name: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          people: [
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
             { min: 11, max:11, message: '请输入正确手机号', trigger: 'blur' }
          ],
          type: [
            { type: 'array', required: true, message: '请至少选择一个合作产品', trigger: 'change' }
          ],
	  },
	   showSelectPage: 0
    }
  },
  methods: {
    // onMouseLeaveNews() {
    //   this.activeNewsIndex = -1;
    // },

    // onMouseEnterNews(val) {

    //   this.activeNewsIndex = val;
    //   console.log(this.activeNewsIndex,"<<<<<<")
    // },
    // onMouseEnter(val) {
    //   console.log(">>>>>>>V>V>V>>VV>",val)
    //   if (val == 1) {
    //     this.isActive1 = true;
    //     this.isActive2 = false;
    //     this.isActive3 = false;
    //   } else if (val==2) {
    //     this.isActive1 = false;
    //     this.isActive2 = true;
    //     this.isActive3 = false;
    //   } else if (val == 3) {
    //     this.isActive1 = false;
    //     this.isActive2 = false;
    //     this.isActive3 = true;
    //   }
    // },
    // onMouseLeave() {
    //   this.isActive1 = false;
    //   this.isActive2 = false;
    //   this.isActive3 = false;
    // },
    // onResize(){
    //   var width = document.documentElement.clientWidth;
    //   console.log(width);
    //   this.setCarouselHeight(width)
    //   this.setHeaderLayout(width)
    // },
    // setHeaderLayout(width){
    //   var cb_c_h = "340px";
    //   if (width <=1200) {
    //     this.vertical=true;
    //     this.horizontal=false;

    //   } else {
    //     this.horizontal=true;
    //     this.vertical=false;
    //   }

    //   if (width >= 1320) {
    //     this.cb_carousel_height="380px";
    //   } else if (width <1320) {
    //     this.cb_carousel_height="340px";
    //   }
    // },
    // setCarouselHeight(width){
    //   this.height = (width / 3.4).toString()+"px";
    //   this.cb_height = (width / 3).toString()+"px";
    //   // this.cb_carousel_height = (width /3)* (3/4).toString() + "px";
    // },
    // handleOpen(index, path){
    //   console.log(index, path)
    // },

    // handleClose(index, path){
    //   console.log(index, path)
    // },
    // handlerClick(){
    //   console.log("wft")
    // },
    submitForm(formName) {
		console.log(this.ruleForm)
		this.$refs[formName].validate((valid) => {
			if (valid) {
				axios.put(this.base+`/rest/coop/api/cooper`, JSON.stringify(this.ruleForm)).then(res => {
					if (res.data.code == 200) {
					this.$alert('申请提交成功，我们将尽快与您取得联系，请保持手机畅通！', '提示', {
						confirmButtonText: '确定',
						callback: action => {
						}
					});
					}
				});
			} else {
			console.log('error submit!!');
			return false;
			}
		});
	},
	handleSelect(val){
		console.log(val)
        var  path = "/website/product_service/#"+val;
        this.$router.push(path);
        this.showSelectPage = val
         
     }
  },
  mounted(){
    // this.onResize();
    // window.addEventListener('resize', this.onResize);

    console.log(">>>>>>index wft")
  }
}
</script>
<style scoped>
.el-menu-select-box li,.el-menu-select-box ul{list-style:none;margin:0;padding:0;}
.el-header {
    /*background-color: #B3C0D1;*/
    /*color: #333;*/
    line-height: 60px;
    margin:0 auto;
    
  }
	
  .news-main {
    /*text-align: center;*/
    margin-top: 60px;
    /* background-color: #F5F5F5; */
  }
  .news-main-container {
    margin:0 auto;
    width: 90%;
    padding-top: 10px;
  }
  .new-menu{
  }
  .new-menu.is-active {
    border-left: solid 2px #409EFF;
	background: #EAF6FF;

  }

  .el-main {
    padding-top: 0px;
    background-color: #FFFFFF;
  }
  .el-menu {
    /* border-right: solid 0px!important; */
	    background: rgba(255,255,255,1);
    box-shadow: 0px 0px 14px 2px rgba(223,223,223,0.68);
    margin: 10px;
  }
  .news-content {
    background-color: #FFFFFF;
    /* margin-left: 20px; */
  } 

  .main-title{
    border-left: solid 4px #409EFF;
    /* padding-top: 10px; */
	/* margin-top: 10px; */
  }


@media screen and (max-width: 600px) {
}
@media screen and (min-width: 1400px) {
}
@media screen and (min-width: 1349px) and (max-width: 1399px) {
  
}
@media screen and (max-width: 1348px) and (min-width: 1000px) {
}

@media screen and (max-width: 500px) and (min-width: 0px) {
}

@media screen and (max-width: 1000px) and (min-width: 500px) {
}
.el-menu-select-box{
	background:rgba(255,255,255,1);
	box-shadow:0px 0px 14px 2px rgba(223,223,223,0.68);
}
.service-content-apy {
  padding-bottom: 30px;
      width: 50%;
    margin: 0 auto;
}
.service-content-apy p{
  text-align: center;
  margin-top: 0px;
}

.form-apy {
  margin:0 auto
}
.el-menu-select-box li{
	margin:0 20px;
	
}
.qyfljc h1{
	/* width:50px; */
	/* height:23px; */
	font-size:24px;
	font-weight:400;
	color:rgba(51,51,51,1);
	/* line-height:18px; */
	margin:45px 0 24px 0;
}
.qyfljc p{
	font-size:14px;
	font-weight:400;
	color:rgba(51,51,51,1);
	line-height:24px;
	padding-bottom:45px;
}
.qyfljc-lxr span{
	font-size:16px;
	color:rgba(51,51,51,1);
	line-height:18px;
}
 ul.platform-box,ul.platform-box1{
	overflow: hidden;
	margin: 0 auto;
    /* text-align: center; */
}
ul.platform-box{
    /* width: 63%; */
	text-align: center;
    justify-content: center;
    display: flex;
}
ul.platform-box1{
    /* width: 92%; */
	display: flex;
    justify-content: center;
}
.platform-box>li,.platform-box1>li{
	float: left;
	/* margin-right:20px; */
}
.platform-box1>li{
	margin-right: 10px;
}
.platform-box>li>img,.platform-box1>li>img{
	margin-bottom:45px;
}
.platform-box1>li>img{
	width:140px;
}
.platform-box>li>p,.platform-box1>li>p{
	font-size: 17px;
	color: #333333;
	text-align: center;
	margin:0;
}
.hardware-roduct>ul,.hardware-roduct li{margin:0;padding:0;list-style:none;}
.hardware-roduct>ul{
	overflow: hidden;
}
.hardware-roduct>ul>li{
	float: left;
	width: 31%;
	margin-right: 15px;
}
.hardware-sm{
	margin-bottom: 50px;
	text-align: center;
}
.hardware-roduct>ul>li .hardware-sm h5{
	font-size: 18px;
	font-weight: normal;
	margin-top:25px;
	margin-bottom:10px; 
	color:#333333;
}
.hardware-roduct>ul>li .hardware-sm span{
	font-size: 12px;
	color:#666666;
}
.hardware-img{
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductService.vue